import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ArticleDetails from '../articles/Articledetails';
import SearchDetailLayout from './SearchDetailLayout';
import { SEARCH_ROUTES } from './searchRoutes';
import { getSearchRouteState, itemId, writeSearchSession } from './searchFlow';

export default function SearchArticleDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const flow = getSearchRouteState(location.pathname, location.state);
  const blogId = Number(flow.id || itemId(flow.selectedRecord, 8));
  useEffect(() => { writeSearchSession(`route:${location.pathname}`, flow); }, [location.pathname, flow]);
  if (!(blogId > 0)) return <SearchDetailLayout title="News & Articles" valid={false} query={{}} goBack={() => navigate(SEARCH_ROUTES.blogs)} />;
  return <ArticleDetails searchContext={{
    blogId,
    stateId: Number(flow.stateId) || 0,
    keyword: flow.searchController || flow.keyword || '',
    backTarget: flow.searchBackTarget || { pathname: SEARCH_ROUTES.blogs, state: flow },
  }} />;
}
